<template>
  <footer class="kl-footer">
    <div class="kl-footer__main">
      <div class="kl-footer__decor" aria-hidden="true"></div>
      <div class="kl-footer__inner">
        <!-- Marca -->
        <div class="kl-footer__brand">
          <img
            src="../../assets/new-page/KL_LOGO_CONTACT.svg"
            alt="KeyLearning"
          />
        </div>

        <!-- Contacto -->
        <div class="kl-footer__col">
          <h3 class="kl-footer__heading">
            {{ $t("home.contact.contactUsTitle") }}
          </h3>
          <a
            class="kl-footer__contact"
            href="https://wa.me/+56977081206"
            target="_blank"
          >
            <b-icon icon="whatsapp" class="kl-footer__icon"></b-icon>
            <span>WhatsApp +56 (9) 7708 1206</span>
          </a>
        </div>

        <!-- Empresa -->
        <div class="kl-footer__col kl-footer__col--company">
          <h3 class="kl-footer__heading">
            {{ $t("home.contact.companyName") }}
          </h3>
          <p class="kl-footer__text">{{ $t("home.contact.address") }}</p>
          <p class="kl-footer__text">
            <strong>{{ $t("home.contact.addressDetail") }}</strong>
          </p>
          <a
            class="kl-footer__social"
            href="https://www.linkedin.com/company/keylearningcl/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn KeyLearning"
          >
            <img src="../../assets/new-page/LINKEDIN_ICON.svg" alt="LinkedIn" />
          </a>
        </div>
      </div>
    </div>

    <div class="kl-footer__bottom">
      {{ $t("home.contact.copyright", { year: currentYear }) }}
    </div>
  </footer>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
// import { generateUniqueId } from "@/utils/utils";
export default {
  name: "ContactBanner",
  components: {},
  props: {},
  data() {
    return {
      currentYear: null,
    };
  },
  computed: {
    // ...mapGetters({}),
  },
  methods: {
    getCurrentYear() {
      const date = new Date();
      this.currentYear = date.getFullYear();
    },
  },
  mounted() {
    // Llama al método para obtener el año actual cuando el componente está montado
    this.getCurrentYear();
  },
  created() {},
};
</script>

<style scoped>
/* ============================================================
   KeyLearning · Pie de página / banner de contacto
   (alineado con el sistema de diseño de la página pública)
   ============================================================ */
.kl-footer {
  /* Migrado al sistema global de tokens (utils/styles_kl.css). */
  --kl-blue: var(--kl-color-primary);
  --kl-blue-dark: var(--kl-color-primary-deep);
  --kl-teal: var(--kl-color-secondary);
}
.kl-footer__main {
  position: relative;
  background: linear-gradient(
    135deg,
    var(--kl-blue-dark) 0%,
    var(--kl-blue) 55%,
    var(--kl-teal) 120%
  );
  color: #ffffff;
  overflow: hidden;
}
.kl-footer__decor {
  position: absolute;
  top: -140px;
  left: -90px;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.12) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}
.kl-footer__inner {
  position: relative;
  z-index: 1;
  max-width: 1180px;
  margin: 0 auto;
  padding: 56px 32px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 48px;
  align-items: center;
}

/* Marca */
.kl-footer__brand img {
  max-width: 200px;
  width: 100%;
  height: auto;
}

/* Columnas */
.kl-footer__col {
  display: flex;
  flex-direction: column;
}
.kl-footer__col--company {
  text-align: right;
  align-items: flex-end;
}
.kl-footer__heading {
  text-align: left !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-title-sm);
  margin: 0 0 14px;
  letter-spacing: -0.01em;
}
.kl-footer__text {
  font-weight: var(--kl-fw-regular);
  font-size: var(--kl-fs-body);
  line-height: var(--kl-lh-base);
  color: rgba(255, 255, 255, 0.92);
  margin: 0 0 4px;
}

/* Contacto (WhatsApp) */
.kl-footer__contact {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: var(--kl-fs-body-lg);
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.25s ease;
}
.kl-footer__contact:hover {
  opacity: 0.85;
  color: #ffffff;
}
.kl-footer__icon {
  font-size: 20px;
}

/* Red social */
.kl-footer__social {
  display: inline-flex;
  margin-top: 14px;
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.kl-footer__social:hover {
  transform: translateY(-3px);
  opacity: 0.9;
}
.kl-footer__social img {
  width: 32px;
  height: 32px;
}

/* Barra inferior */
.kl-footer__bottom {
  background: var(--kl-blue-dark);
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
  font-size: var(--kl-fs-caption);
  font-weight: var(--kl-fw-regular);
  padding: 16px 20px;
}

/* ============================================================
   Responsive
   ============================================================ */
@media (max-width: 900px) {
  .kl-footer__inner {
    grid-template-columns: 1fr;
    gap: 36px;
    text-align: center;
    justify-items: center;
    padding: 48px 24px;
  }
  .kl-footer__col,
  .kl-footer__col--company {
    text-align: center;
    align-items: center;
  }
}
</style>
